import { Results } from './Results';

export interface MinimalProject {
  projectName?: string;
  projectId: number;
}

export default Results;
